import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

const SettingsMenu = lazy(() => import('./SettingsMenu'))
const ConversionMenu = lazy(() => import('./ConversionMenu'))
const GalleryMenu = lazy(() => import('./GalleryMenu'))
const AlbumMenu = lazy(() => import('./AlbumMenu'))

interface Props {
  isPublic?: boolean
}

export default function AuthenticatedMenu({ isPublic }: Props) {
  return (
    <div style={{ flex: 1, textAlign: 'right' }}>
      <Suspense fallback={null}>
        <Routes>
          <Route path="albums" element={<AlbumMenu />} />
          <Route path="a/:albumId/subalbums" element={<AlbumMenu />} />
          <Route path="s/dashboard" element={<SettingsMenu />} />
          {['/', 'a/:albumId', 'd/*', 'v/day', '/search', '/favorites'].map((mediaPath) => (
            <Route key={mediaPath} path={mediaPath} element={<GalleryMenu isPublic={!!isPublic} />} />
          ))}
          <Route path="*" element={<ConversionMenu isPublic={!!isPublic} />} />
        </Routes>
      </Suspense>
    </div>
  )
}

AuthenticatedMenu.defaultProps = {
  isPublic: false
}
